// src/slices/index.js
import { combineReducers } from "redux";

import MediaReducer from "./0-media/reducer";
import authReducer from "./1-auth/1-login/reducer";
import myProfileReducer from "./1-auth/2-myProfile/reducer";
import formsReducer from "./5-formsWorkSpace/reducer";
import contactReducer from "./8-Contact-us/reducer";
import formReducer from "./10-forms/reducer";
import locationReducer from "./2-location/reducer";
import postsReducer from "./post/reducer";
import articleReducer from "./article/reducer";
import animalPriceReducer from "./price/reducer";
import companyReducer from "./companyprice/reducer";
import profileReducer from "./profile/reducer";
import categoryReducer from "./category/reducer";
import bankReducer from "./banks/reducer";
import sponsorReducer from "./sponsor/reducer";
import adsReducer from "./ads/reducer";
import companyGpsReducer from "./companygps/reducer";
import podcastReducer from "../slices/podcast/reducer";
import productReducer from "../slices/product/reducer";
import shipTrafficReducer from "../slices/shiptrafic/reducer";
import shipTrafficAllReducer from "../slices/shipessitional/reducer";
import productStoreDataReducer from "../slices/productstore/reducer";
import jobReducer from "../slices/job/reducer";
import shipCompanyReducer from "../slices/shipcomapany/reducer";
import writerReducer from "../slices/writer/reducer";
import navItemReducer from "../slices/navbar/reducer";
import weatherReducer from "../slices/weather/reducer";
import customsReleaseReducer from "../slices/customsrelease/reducer";
import subscriptionReducer from "../slices/subscription/reducer";
import animalReducer from "../slices/Animal/reducer";
const rootReducer = combineReducers({
  auth: authReducer,
  Media: MediaReducer,
  myProfile: myProfileReducer,
  location: locationReducer,
  category: categoryReducer,
  bank: bankReducer,
  writer: writerReducer,
  customsRelease: customsReleaseReducer,
  shipCompany: shipCompanyReducer,
  sponsor: sponsorReducer,
  ads: adsReducer,
  subscription: subscriptionReducer,
  animal: animalReducer,

  companyGps: companyGpsReducer,
  podcast: podcastReducer,
  product: productReducer,
  shipTraffic: shipTrafficReducer,
  shipTrafficAll: shipTrafficAllReducer,
  productStoreData: productStoreDataReducer,
  job: jobReducer,
  weather: weatherReducer,
  navItem: navItemReducer,
  forms: formsReducer,
  posts: postsReducer,
  animalPrice: animalPriceReducer,
  company: companyReducer,
  profile: profileReducer,

  contact: contactReducer,
  form: formReducer,
  article: articleReducer
});

export default rootReducer;
